import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LandingLogo from './LandingLogo';
import './landing-animations.css';
import './landing-theme.css';

const HASH_LINKS = [
  { hash: '#workforce', label: 'Workforce' },
  { hash: '#ai-future', label: 'AI Learning' },
  { hash: '#ethora-bot', label: 'Ethora Bot' },
  { hash: '#skills-based', label: 'Skills-Based' },
];

const LandingNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const handleHashNav = (hash) => {
    setExpanded(false);
    if (location.pathname === '/') {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    navigate(`/${hash}`);
  };

  return (
    <Navbar
      bg="white"
      variant="light"
      className="py-2 fixed-top landing-nav-bar"
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container className="container2">
        <Navbar.Brand as="div" className="animate-fade-left mb-0">
          <LandingLogo variant="light" layout="lockup" size="md" showProductName={false} />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="landing-navbar" className="border-0 shadow-none" />

        <Navbar.Collapse id="landing-navbar">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link as={Link} to="/" className="landing-nav-link" active={location.pathname === '/'}>
              Home
            </Nav.Link>

            {HASH_LINKS.map(({ hash, label }) => (
              <Nav.Link
                key={hash}
                as="button"
                type="button"
                className="landing-nav-link landing-nav-link-hash border-0 bg-transparent"
                onClick={() => handleHashNav(hash)}
                aria-label={`Go to ${label}`}
              >
                {label}
              </Nav.Link>
            ))}

            <Nav.Link as={Link} to="/enquiry" className="landing-nav-link" active={location.pathname === '/enquiry'}>
              Enquiry
            </Nav.Link>

            <Nav.Link as={Link} to="/login" className="landing-nav-cta" active={location.pathname === '/login'}>
              Sign In
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default LandingNavbar;
